module.exports = __webpack_public_path__ + "img/all_out.517ee48b.svg";